import moment from 'moment'

/**
 *
 * @param path
 * @param obj
 * @param defaultValue
 * @returns {*}
 */
function getNested(path, obj, defaultValue = false) {
    let value = path.split('.').reduce((prev, curr) => (prev ? prev[curr] : null), obj || self)
    return value === null || value === undefined ? defaultValue : value
}

/**
 * Deep copy the given object.
 *
 * @param  {Object} obj
 * @return {Object}
 */
function deepCopy(obj) {
    if (obj === null || typeof obj !== 'object')
        return obj

    const copy = Array.isArray(obj) ? [] : {}

    Object.keys(obj).forEach(key => {
        copy[key] = deepCopy(obj[key])
    })

    return copy
}

/**
 * For comparing objects. Transforms obj in json string and remove quotes for type matching
 */
function objectToString(obj, removeQuotes = true) {
    return JSON.stringify(obj, Object.keys(obj).sort()).replace(/\"/g, '')
}

/**
 *
 * @param obj
 * @param prefix
 * @returns {string}
 */
function serialize(obj, prefix = '?') {
    var str = [], p;
    for (p in obj) {
        if (obj.hasOwnProperty(p)) {
            var k = p, v = obj[p];
            str.push((v !== null && typeof v === "object") ?
                serialize(v, k) :
                encodeURIComponent(k) + "=" + encodeURIComponent(v));
        }
    }
    return (prefix ? prefix : '') + str.join("&");
}

/**
 *
 * @param value
 * @param total
 * @returns {number}
 */
function percent(value, total) {
    if (isNaN(value)) return '0'
    return Math.floor(value / total * 100)
}

/**
 *
 * @param path
 * @returns {string}
 */
function fullUrl(path) {
    return config.appUrl + path
}

/**
 * Formats the given number of hours to hh(h)mm. So, if the value is 2.5, the result will be "02h30"
 *
 * @param minutes
 * @returns {string}
 */
function formatHour(minutes) {
    if (isNaN(minutes)) return '00h00'
    var hours = Math.floor(minutes / 60)
    minutes %= 60
    return ("0" + hours).slice(-2) + 'h' + ("0" + minutes).slice(-2)
}

/**
 * Returns a array of { label: "label", value: "value" } transformed from a [ key: value ] array
 * where the key becomes the new value and the old value becomes the label. In the hypothesis
 * of giving the other params, it will map the given array (obj) plucking it to the format
 *
 * @param obj
 * @param label
 * @param value
 * @returns {Array}
 */
function labelValueFrom(obj, label = null, value = null) {
    if (!label)
        return Object.keys(obj).map(key => ({
            label: obj[key], value: key
        }))
    return obj.map(item => ({
        label: item[label],
        value: item[value]
    }))
}

/**
 *
 * @param fullName
 * @param lastNameFirst
 * @returns {string}
 */
function firstAndLast(fullName, lastNameFirst = false) {
    if (!fullName) return
    var firstName = fullName.split(' ')[0]
    var lastName = fullName.split(' ').slice(-1).join()
    if (firstName !== lastName)
        return lastNameFirst ? `${lastName}, ${firstName}` : `${firstName} ${lastName}`
    return firstName
}

/**
 *
 * @param vm
 * @param parentObj
 * @param childName
 * @param index
 */
function reactiveRemoveFrom(vm, parentObj, childName, index) {
    var arrCopy = deepCopy(parentObj[childName])
    arrCopy.splice(index, 1)
    parentObj[childName] = []
    vm.$nextTick(() => vm.$set(parentObj, childName, arrCopy))
}

/**
 *
 * @param array
 * @param attr
 * @param value
 * @returns {number}
 */
function indexBy(attr, value, array) {
    for (var i = 0; i < array.length; i++)
        if (array[i][attr] == value) return i
    return -1
}

import {format, date} from 'quasar-framework'

const {humanStorageSize, between, pad} = format

/**
 * Overrides the Quasar capitalize method, so it can check for empty strings
 *
 * @param str
 * @returns {*}
 */
function capitalize(str) {
    if (str)
        return format.capitalize(str)
}

/**
 *
 * @param unique_title
 * @returns {StyleSheet}
 */
function getStyleSheet(unique_title) {
    for (var i = 0; i < document.styleSheets.length; i++) {
        var sheet = document.styleSheets[i]
        if (sheet.title == unique_title)
            return sheet
    }
}

/**
 *
 * @param selector
 * @param sheet
 * @returns {CSSRule}
 */
function getCssRuleIndexBy(selector, sheet) {
    for (var i = 0; i < sheet.cssRules.length; i++) {
        var rule = sheet.cssRules[i]
        if (rule.selectorText == selector)
            return i
    }
}

/**
 *
 * @param str
 * @param size
 * @returns {string}
 */
function abbreviate(str, size = 3) {
    return str.split(' ').map(word => (word.length > size ? word.substring(0,size) + '.' : word)).join(' ')
}

/**
 *
 * @param val
 * @param limitUnity
 * @param limit
 * @returns {string}
 */
function niceDate(val, outFormat, limitUnity = 'days', limit = 1, inFormat = 'YYYY-MM-DD HH:mm:ss') {
    let day = moment(val, inFormat)
    return moment().diff(day, limitUnity) > limit ? day.format(outFormat) : day.fromNow()
}

/**
 *
 * @param str
 * @param tokens
 * @returns {string}
 */
function strTokenReplace(str, tokens) {
    Object.keys(tokens).forEach(token => str = str.replace(new RegExp(`:${token}`, 'g'), tokens[token]))
    return str
}

function isValidDniNiePassport(value) {
    let nifRegex = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]$/i
    let nieRegex = /^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/i
    let passportRegex = /^[a-z]{3}[0-9]{6}[a-z]?$/i

    return nifRegex.test(value) || nieRegex.test(value) || passportRegex.test(value)
}

function isValidEmail(value) {
    let emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
    return emailRegex.test(value)
}

function isValidESZipCode(value) {
    let zipCodeRegex = /^((0[1-9]|5[0-2])|[1-4][\d])[\d]{3}$/
    return zipCodeRegex.test(value)
}

function isValidMobilePhone(value) {
    let mobilePhoneRegex = /(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{1,14}$/
    return mobilePhoneRegex.test(value)
}

export default {
    getNested, deepCopy, serialize, percent, formatHour, fullUrl, getStyleSheet, getCssRuleIndexBy,
    labelValueFrom, firstAndLast, reactiveRemoveFrom, indexBy, objectToString, abbreviate,
    capitalize, humanStorageSize, between, pad, date, niceDate, strTokenReplace, isValidDniNiePassport, isValidEmail,
    isValidESZipCode, isValidMobilePhone
}


// WEBPACK FOOTER //
// ./resources/assets/js/helpers/methods.js